import styled from 'styled-components'
import { Dialog as MuiDialog } from '@material-ui/core'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'
import { H5 } from '@components/Text'

export const Dialog = styled(MuiDialog)`
  .MuiDialog-paper {
    position: fixed;
    top: 0;
    right: 0;
    margin: 0;
  }

  .MuiDialog-paperScrollPaper {
    max-height: 100%;

    @media (min-width: ${getBreakpoint('xl')}px) {
      height: 100vh;
    }
  }
`

export const DialogHeader = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 20px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 16px;
    align-items: flex-start;
  }
`

export const Title = styled(H5)`
  font-weight: 700;
  line-height: 32px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 48px;
    margin-left: 48px;
  }
`

export const CloseIcon = styled(Image)`
  width: 24px;
  height: 24px;
  cursor: pointer;
`
